import React from "react";
import {Dialog} from "evergreen-ui";


const ConfirmationDialog = (props) => {

    const {
        showDialog,
        isShown,
        header,
        confirmLabel,
        cancelLabel,
        intent,
        information,
        action,
        closeAction,
    } = props;

    return (
        <Dialog
            isShown={isShown}
            hasHeader={!!header}
            title={header}
            onCloseComplete={() => {
                showDialog(false);
                if(closeAction) {
                    closeAction()
                }
            }}
            confirmLabel={confirmLabel}
            hasCancel={!!cancelLabel}
            cancelLabel={cancelLabel}
            intent={intent}
            topOffset={180}
            onConfirm={() => action()}
            minHeightContent={30}
        >
            {information}
        </Dialog>
    )
};

export default ConfirmationDialog;
